import { DataModel } from "common/models/utility-models/base-model"

export class InternshipDetailsModel extends DataModel {
    // isStudentAvailable:any=''
    // semesterExamStart:any=''
    // semesterExamEnds:any=''
    // summerVacationStarts:any=''
    // summerVacationEnds:any=''
    // isExternalCompanyForInternship:any = ''
    // internshipStartDate:any=''
    // internshipEndDate:any=''
    // remarks:any=''
    detail:any = ''
}
